import React from 'react'
import { CardHeader, Typography, Box, Button } from '@mui/material'
import { IoChevronBackOutline } from 'react-icons/io5'
import { CompChat, Loading } from '../../Simple'
import { AppBarBottom } from '../../Complex'
import { ChatContext } from '../../../contexts/ChatContext'
import RouterHook from '../../../contexts/RouterHook'
import ChatSelMob from './ChatSelMob'

import { stMob, stylesDesk } from './stylesChat'
import { LocalStorage } from '../../../services'

export default function MobileChat() {
  const serverRouter = RouterHook()
  const { sttChatCtx, actionsChatCtx, loadsChat } = React.useContext(ChatContext)
  const [loadCmp, setLoadCmp] = React.useState(false)
  const listChatsRef = React.useRef(null)

  React.useEffect(() => {
    const chatSelected = LocalStorage.get('chat-selected')

    if (chatSelected) {
      if (chatSelected.mode === 'agendamentos') {
        if (sttChatCtx.chatMNLP || !sttChatCtx.pesquisedAgends) {
          actionsChatCtx.BuscarChatAgendamentos(true)
        } else {
          actionsChatCtx.AbrirChatPedido(chatSelected.id)
        }
      } else {
        if (sttChatCtx.chatMNLE || !sttChatCtx.pesquisedDirects) {
          actionsChatCtx.BuscarChatDiretos(true)
        } else {
          actionsChatCtx.AbrirChatDireto(chatSelected.id)
        }
      }
    } else if (sttChatCtx.chatMNLP || (sttChatCtx.modeChat === 'agendamentos' && !sttChatCtx.pesquisedAgends)) {
      actionsChatCtx.BuscarChatAgendamentos(true)
    } else if (sttChatCtx.chatMNLE || (sttChatCtx.modeChat === 'diretos' && !sttChatCtx.pesquisedDirects)) {
      actionsChatCtx.BuscarChatDiretos(true)
    } else {
      actionsChatCtx.BuscarChatAgendamentos(true)
    }
  }, [sttChatCtx.modeChat])

  let flagRef = React.useRef(false)
  React.useEffect(() => {
    const handleScroll = () => {
      if (listChatsRef.current && listChatsRef.current.scrollTop + listChatsRef.current.clientHeight >= listChatsRef.current.scrollHeight - 10) {
        if (sttChatCtx.modeChat === 'agendamentos' && !loadsChat.chatPagination && !flagRef.current) {
          if (sttChatCtx.chatsAgends.length < sttChatCtx.maxScroll) {
            flagRef.current = true
            actionsChatCtx.BuscarChatAgendamentos(false).then(() => {
              flagRef.current = false
            })
          }
        } else if (sttChatCtx.modeChat === 'diretos' && !loadsChat.chatPagination && !flagRef.current) {
          if (sttChatCtx.chatsDirects.length < sttChatCtx.maxScroll) {
            flagRef.current = true
            actionsChatCtx.BuscarChatDiretos(false).then(() => {
              flagRef.current = false
            })
          }
        }
      }
    }

    const currentRef = listChatsRef.current
    if (currentRef) {
      currentRef.addEventListener('scroll', handleScroll)
    }
    return () => {
      if (currentRef) {
        currentRef.removeEventListener('scroll', handleScroll)
      }
    }
  }, [sttChatCtx.modeChat, loadsChat, sttChatCtx.chatsAgends, sttChatCtx.chatsDirects])

  return (
    <div className='contain-page-mobile'>
      {sttChatCtx.chat === null ? (
        <>
          <CardHeader
            sx={stMob.containHeader}
            avatar={
              <IoChevronBackOutline
                size={30}
                style={stMob.iconBack}
                onClick={() => {
                  serverRouter('back')
                }}
              />
            }
            title={
              <Typography variant='h6' sx={stMob.titlePage}>
                Conversas
              </Typography>
            }
          />
          <Box sx={stylesDesk.containBtts}>
            <Button
              fullWidth
              sx={sttChatCtx.modeChat === 'agendamentos' ? stylesDesk.btnActive : stylesDesk.btnInactive}
              onClick={() => {
                if (sttChatCtx.modeChat !== 'agendamentos') actionsChatCtx.handleModeChat('agendamentos')
              }}
            >
              Agendamentos
            </Button>
            <Button
              fullWidth
              sx={sttChatCtx.modeChat === 'diretos' ? stylesDesk.btnActive : stylesDesk.btnInactive}
              onClick={() => {
                if (sttChatCtx.modeChat !== 'diretos') actionsChatCtx.handleModeChat('diretos')
              }}
            >
              Mensagens Diretas
            </Button>
          </Box>
          <Box sx={stMob.containListChats} ref={listChatsRef}>
            {loadsChat.listChat ? (
              <div className='contain-loading'>
                <Loading text={'Carregando conversas...'} />
              </div>
            ) : sttChatCtx.modeChat === 'agendamentos' ? (
              sttChatCtx.chatsAgends.map((chat, index) => (
                <React.Fragment key={index}>
                  {loadCmp === index ? (
                    <Loading />
                  ) : (
                    <>
                      <CompChat
                        key={index}
                        chat={chat}
                        onClick={() => {
                          if (sttChatCtx.chat?.idchat !== chat.idchat && !loadsChat.chatSelected) {
                            setLoadCmp(index)
                            actionsChatCtx.SelectChatAgend(chat.idchat).then(() => {
                              setLoadCmp(false)
                            })
                          }
                        }}
                      />
                      <Box sx={stMob.containList} />
                    </>
                  )}
                </React.Fragment>
              ))
            ) : (
              sttChatCtx.chatsDirects.map((chat, index) => (
                <CompChat
                  key={index}
                  chat={chat}
                  onClick={() => {
                    if (sttChatCtx.chat?.idchat !== chat.idchat && !loadsChat.chatSelected) {
                      actionsChatCtx.SelectChatDirect(chat.idchat)
                    }
                  }}
                />
              ))
            )}
            {loadsChat.chatPagination && <Loading />}
          </Box>
          <div className='contain-mb-app-bar-btt' />
          <AppBarBottom />
        </>
      ) : (
        <ChatSelMob />
      )}
    </div>
  )
}
